import React from "react";

import Icon from "../../components/Icon";
import { SoonPill } from "../../components/GestaoTeaser";

/**
 * Configuração da coluna de vínculos para a tela de pedido (BDM-1051):
 * ícone, "ver todos" e destino de cada item. O componente LinkedRecords é
 * genérico — é aqui que o pedido diz para onde cada coisa leva.
 */

export const ORDER_CHAIN_LABELS = {
    budget: 'Orçamento',
    order: 'Pedido',
    purchase: 'Compra',
    entry: 'Entrada',
    invoice: 'NF-e',
};

// Mesmo recorte que a aba "Financeiro e compras" já usa para abrir as listas.
const orderScope = order =>
    `order_id=${order?.id}${order?.code ? `&order_code=${encodeURIComponent(order.code)}` : ''}`;

export const orderLinksConfig = order => ({
    crm_cards: { icon: 'waypoints' },
    budget: { icon: 'quote' },
    receivables: { icon: 'money', listTo: `/finance/receivables?${orderScope(order)}` },
    payables: { icon: 'ticket', listTo: `/finance/payables?${orderScope(order)}` },
    purchase_orders: { icon: 'order', listTo: `/purchase-order/list?${orderScope(order)}` },
    purchase_invoices: { icon: 'inbox', listTo: '/purchase-invoice/list' },
    fiscal_documents: { icon: 'receipt-text', listTo: '/fiscal/documents' },
    bankslips: { icon: 'pdf' },
});

export const orderLinksItemTo = (order, openPurchaseOrder) => item => {
    switch (item.entity) {
        case 'crm_card':
            return `/crm/card/${item.id}`;
        case 'budget':
            return `/quote/edit/${item.id}`;
        case 'fiscal_document':
            return `/fiscal/documents/${item.id}`;
        case 'receivable':
            return `/finance/receivables?${orderScope(order)}`;
        case 'payable':
            return `/finance/payables?${orderScope(order)}`;
        case 'purchase_order':
            return () => openPurchaseOrder({ id: item.id });
        case 'purchase_invoice':
            return `/purchase-invoice/list?search=${encodeURIComponent(item.title.replace('NF ', ''))}`;
        default:
            return null;
    }
};

const GESTAO_GROUPS = [
    { key: 'receivables', label: 'Contas a receber' },
    { key: 'payables', label: 'Contas a pagar' },
    { key: 'purchase_orders', label: 'Pedidos de compra' },
    { key: 'purchase_invoices', label: 'Notas de entrada' },
    { key: 'fiscal_documents', label: 'Notas fiscais' },
];

/**
 * Grupos do módulo Gestão quando o plano não libera: em breve só informa,
 * fora do plano cada linha abre o convite para contratar.
 */
export const orderGestaoPlaceholders = onLockedClick => GESTAO_GROUPS.map(group => ({
    ...group,
    hint: onLockedClick ? 'não incluso no plano' : 'em breve',
    trail: onLockedClick ? <Icon name="lock" size={14} className="linked-lock" /> : <SoonPill />,
    onClick: onLockedClick,
}));
